import aide from '@/services/api/compte/aide';
import { bus } from '@/main';

const state = {
  isAideActif: false,
  idRubriqueAide: [],
  listeQuestionsReponses: null,
  lienYoutube: '',
};

const actions = {
  async initRubriqueAide({ state, commit }, { idRubriqueAide, lienYoutube }) {
    commit('SET_ID_RUBRIQUE_AIDE', idRubriqueAide);
    commit('SET_AIDE_LIEN_YOUTUBE', lienYoutube);

    if (state.idRubriqueAide.length > 0 && state.isAideActif) {
      await aide
        .getQuestionsReponses(state.idRubriqueAide)
        .then((listeQuestionsReponses) => {
          commit('SET_LISTE_QUESTIONS_REPONSES', listeQuestionsReponses);
        })
        .catch((error) => {
          commit('SET_LISTE_QUESTIONS_REPONSES', null);
        });
    } else {
      commit('SET_LISTE_QUESTIONS_REPONSES', null);
    }
  },
  // idAide: Ouvrir l'aide avec zone escamotable ouverte sur idAide
  async toggleAide({ state, commit }, idAide = null) {
    // On reset la liste des questions/réponses
    commit('SET_LISTE_QUESTIONS_REPONSES', null);
    if (!idAide || !state.isAideActif) {
      // A la fermeture du panneau d'aide on supprime l'ancre
      if (window.location.hash) {
        window.history.pushState(
          '',
          document.title,
          window.location.pathname + window.location.search
        );
      }
      commit('SET_IS_AIDE_ACTIF', !state.isAideActif);
    }
    if (state.idRubriqueAide.length > 0 && state.listeQuestionsReponses == null) {
      await aide
        .getQuestionsReponses(state.idRubriqueAide)
        .then((listeQuestionsReponses) => {
          commit('SET_LISTE_QUESTIONS_REPONSES', listeQuestionsReponses);
          if (idAide) {
            const questionReponse = listeQuestionsReponses.find(
              (questionReponse) => questionReponse.id === idAide
            );
            if (questionReponse) {
              window.location.hash = questionReponse.name;
              bus.$emit('ouvrirZoneEscamotable', questionReponse.name);
            }
          }
        })
        .catch((error) => {
          commit('SET_LISTE_QUESTIONS_REPONSES', null);
        });
    }
  },
};

const mutations = {
  SET_IS_AIDE_ACTIF(state, value) {
    state.isAideActif = value;
  },
  SET_ID_RUBRIQUE_AIDE(state, value) {
    state.idRubriqueAide = value;
  },
  SET_LISTE_QUESTIONS_REPONSES(state, value) {
    state.listeQuestionsReponses = value;
  },
  SET_AIDE_LIEN_YOUTUBE(state, value) {
    state.lienYoutube = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
